const unique = (items) => [...new Set(items)];

export const getTotalAttendance = (years = []) => years
  .reduce((total, year) => total + (year.attendees || []).length, 0);

export const getUniqueAttendees = (years = []) => unique(
  years.flatMap((year) => year.attendees || []),
);

export const getUniqueRestaurants = (years = []) => unique(
  years.flatMap((year) => year.restaurants || []),
);

export const getTotalRestaurantVisits = (years = []) => years
  .reduce((total, year) => total + (year.restaurants || []).length, 0);

export const getTotalActivities = (years = []) => years
  .reduce((total, year) => total + (year.activities || []).length, 0);

export const getRecurringRestaurantVisits = (years = []) => {
  const visitsByName = new Map();

  years.forEach((year) => {
    (year.restaurants || []).forEach((name) => {
      const visit = visitsByName.get(name) || { name, years: [] };
      visit.years.push(year.year);
      visitsByName.set(name, visit);
    });
  });

  return [...visitsByName.values()]
    .map((visit) => ({
      ...visit,
      years: unique(visit.years).sort((a, b) => a - b),
      visitCount: visit.years.length,
      location: 'Las Vegas, Nevada',
    }))
    .sort((a, b) => (
      b.visitCount - a.visitCount
      || Math.max(...b.years) - Math.max(...a.years)
      || a.name.localeCompare(b.name)
    ));
};

export const getRecurringActivities = (years = [], activityMetadata = {}) => years
  .flatMap((year) => (year.activities || []).map((title) => {
    const metadata = activityMetadata[title] || {};
    return {
      title,
      year: year.year,
      ...metadata,
      category: metadata.category || 'Team Activity',
    };
  }));

export const getRecurringAttendees = (years = [], crewDirectory = {}) => {
  const attendanceByName = new Map();

  years.forEach((year) => {
    (year.attendees || []).forEach((name) => {
      const attendance = attendanceByName.get(name) || { name, years: [] };
      attendance.years.push(year.year);
      attendanceByName.set(name, attendance);
    });
  });

  return [...attendanceByName.values()]
    .map((attendance) => ({
      ...attendance,
      years: unique(attendance.years).sort((a, b) => a - b),
      attendanceCount: attendance.years.length,
      ...(crewDirectory[attendance.name] || {}),
    }))
    .sort((a, b) => (
      b.attendanceCount - a.attendanceCount
      || Math.min(...a.years) - Math.min(...b.years)
      || a.name.localeCompare(b.name)
    ));
};

export const getRecurringEventStats = (years = [], activities = []) => [
  {
    id: 'years-attended', label: 'Years Attended', value: years.filter((year) => year.status === 'published').length, icon: 'mdi-calendar-multiple',
  },
  {
    id: 'total-attendance', label: 'Total Attendance Across All Years', value: getTotalAttendance(years), icon: 'mdi-account-group-outline',
  },
  {
    id: 'unique-crew', label: 'Unique Crew Members', value: getUniqueAttendees(years).length, icon: 'mdi-account-multiple-check-outline',
  },
  {
    id: 'restaurant-visits', label: 'Restaurants Visited', value: getTotalRestaurantVisits(years), icon: 'mdi-silverware-fork-knife',
  },
  {
    id: 'unique-restaurants', label: 'Unique Restaurants', value: getUniqueRestaurants(years).length, icon: 'mdi-map-marker-star-outline',
  },
  {
    id: 'team-activities', label: 'Team Activities', value: getTotalActivities(years), icon: 'mdi-compass-outline',
  },
  {
    id: 'sphere-shows', label: 'Sphere Shows', value: activities.filter((activity) => activity.title.includes('Sphere')).length, icon: 'mdi-music-circle-outline',
  },
  {
    id: 'national-parks', label: 'National Parks Visited', value: unique(activities.filter((activity) => activity.category === 'National Park').map((activity) => activity.title)).length, icon: 'mdi-pine-tree',
  },
];
